import React from "react";
import styles from "./Chip.module.css";

interface ChipProps {
  id: string;
  icon: React.ReactNode;
  text: string;
  selected?: boolean;
  onClick?: () => void;
}

export const Chip: React.FC<ChipProps> = ({
  id,
  icon,
  text,
  selected = false,
  onClick,
}) => {
  return (
    <button
      className={`${styles.chip} ${selected ? styles.selected : ""}`}
      data-chip-id={id}
      onClick={onClick}
    >
      <div className={styles.icon}>{icon}</div>
      <span className={styles.text}>{text}</span>
    </button>
  );
};
